(function() {
  "use strict";

  angular.module("sempraWebapp").component("globalNotice", {
    templateUrl: "app/components/globalNotice/globalNotice.component.html",
    controller: noticeController,
    bindings: {},
    controllerAs: "vm"
  });

  function noticeController($log, newsActions, webSocketsStore, $timeout, checkUserRole, sessionData) {
    var vm = this,
      today = new Date().getTime(),
      _onNoticeDataChangeHandler = refreshNoticeData;

    vm.$onInit = function() {
      refresh();
      webSocketsStore.on(
        webSocketsStore.events.NOTICE_CHANGE,
        _onNoticeDataChangeHandler
      );
    };

    vm.close = function() {
      vm.showContent = !vm.showContent;
    };

    function refresh() {
      if (checkUserRole.hasAcceptNewTerms(sessionData.getValue('userRole'))) {
        return;
      }
      newsActions.getGlobalNotice().then(function(res) {
        if (res.length > 0) {
          vm.content = res[0].content;
          vm.showContent = res[0].validUntil > today && res[0].active;
        }
      });
    }

    function refreshNoticeData(newNoticeData) {
      $timeout(function() {
        vm.content = newNoticeData.content;
        vm.showContent = newNoticeData.validUntil > today && newNoticeData.active;
      }, 50);
    }
  }
})();
